import { getUserInfo } from '@/lib/auth.js';

export function useAdminAccess() {
  const userInfo = getUserInfo();
  const groups = userInfo?.['cognito:groups'] || [];
  const service = userInfo?.['custom:service'] || '';

  const isPowerUser = groups.includes('PowerUser');
  const isSuperAdmin = groups.includes('SuperAdmin');
  const isAdminOrSuperAdmin = isPowerUser || isSuperAdmin;
  const canManageAllOrgs = service === '*';

  const canManageUserInOrg = (org) => {
    if (!isAdminOrSuperAdmin) return false;
    if (service === '*') return true;
    return service.split(',').map(s => s.trim()).includes(org);
  };

  return { isPowerUser, isSuperAdmin, isAdminOrSuperAdmin, canManageAllOrgs, canManageUserInOrg, service, groups };
}
